export default __webpack_public_path__ + "static/media/inspect2.0596ce29.jpg";